// extracted by mini-css-extract-plugin
export default {"img_icon":"TitleImg_img_icon__xiWR7","title_text":"TitleImg_title_text__7xf9b","title_text_highlight":"TitleImg_title_text_highlight__4ew5Y"};